import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 80vh;
`;

export const FormBox = styled.div`
  background: var(--background-color);
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
`;

export const Description = styled.p`
  color: var(--text-color);
  text-align: center;
  margin-bottom: 40px;
  font-size: 16px;
  line-height: 1.6;
`;
